import Container from "../components/ui/Container/Container";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { QueryKey } from "../services/query-keys";
import ErrorsAlert from "../components/ErrorsAlert/ErrorsAlert";
import { ErrorResponse } from "../custom-fetch";
import Spinner from "../components/ui/Spinner/Spinner";
import { useReservationService } from "../services/reservations-service";
import IReservation from "../shared/IReservation";
import ReservationEdit from "../components/Reservations/ReservationEdit";

type Params = {
  refNo: string;
  irn?: string;
};

const ReservationPage: React.FC = () => {
  const { irn, refNo } = useParams<Params>();
  const { getReservation } = useReservationService();
  
  const {
    data: reservation,
    isLoading,
    isError,
    error,
  } = useQuery<IReservation, ErrorResponse>({
    queryKey: [QueryKey.reservations, refNo, irn],
    queryFn: ({ signal }) => getReservation({ signal, irn, refNo: refNo! }),
  });

  return (
    <div style={{ display: "flex", justifyContent: "center"}}>
      <Container>
        {isError ? (
          <ErrorsAlert errors={error.messages} />
        ) : isLoading ? (
          <Spinner />
        ) : (
          reservation && <ReservationEdit reservation={reservation} />
        )}
      </Container>
    </div>
  );
};

export default ReservationPage;
